import PropTypes from 'prop-types';
import React from 'react';

import ModalTerms from '../../ModalTerms';
import MessageText from '../MessageText';

export const MessageAcceptTerms = (props) => {
  return (
    <>
      <MessageText
        id={props.question.id}
        text={props.question.text}
        html_id="message-terms"
        data-testid="message-terms"
        data-aut-test="message-terms"
      />
      <ModalTerms {...props} />
    </>
  );
};

MessageAcceptTerms.propTypes = {
  question: PropTypes.object
};
